import { useEffect } from 'react'
import { useAssessment } from '../../context/AssessmentContext'
import { getDASSSeverity } from '../../data/dassQuestions'
import Shell from '../ui/Shell'
import { pulse } from '../ui/LightField'
import AgeSection from './results/AgeSection'
import ScalesSection from './results/ScalesSection'
import AreasSection from './results/AreasSection'
import UnlockPanel from './results/UnlockPanel'
import LifeImpactSection from './results/LifeImpactSection'
import MentalHealthSection from './results/MentalHealthSection'
import ProfileSection from './results/ProfileSection'
import ResultsFooter from './results/ResultsFooter'

function ResultsPage() {
  const { state, dispatch } = useAssessment()
  const m = state.investorMetrics
  const extended = !!state.extendedAssessmentComplete

  // Arrival bloom: the readout is the moment the field goes warm.
  useEffect(() => {
    pulse(1.4, { x: 0.3, y: 0.3 })
  }, [])

  if (!m || !state.dassScores) {
    return (
      <Shell label="Results">
        <div className="flow">
          <div className="flow__head">
            <h1>No results yet</h1>
            <p className="flow__lede">Finish the assessment to see your readout.</p>
          </div>
          <div className="flow__actions">
            <button type="button" className="btn btn--block" onClick={() => dispatch({ type: 'RESET_ASSESSMENT' })}>Start the assessment</button>
          </div>
        </div>
      </Shell>
    )
  }

  const severities = {
    depression: getDASSSeverity(state.dassScores.depression, 'depression'),
    anxiety: getDASSSeverity(state.dassScores.anxiety, 'anxiety'),
    stress: getDASSSeverity(state.dassScores.stress, 'stress'),
  }
  const areaCount = Object.keys(state.addictionResults || {}).length
  const date = new Date(m.timestamp || Date.now()).toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' })

  return (
    <Shell label="Your readout">
      <main className="results">
        <header className="results__head">
          <h1>Your readout</h1>
          <div className="results__meta">
            <span>{date}</span>
            <span>{areaCount} {areaCount === 1 ? 'area' : 'areas'}</span>
            <span>{extended ? 'DASS-21, full' : 'DASS-21, short form'}</span>
            {state.submittedEmail && <span>{state.submittedEmail}</span>}
          </div>
        </header>

        <AgeSection age={m.betterStepAge} hasLifestyle={extended} />
        <ScalesSection resilience={m.resilienceIndex} wq={m.wellnessQuotient} />
        <AreasSection results={state.addictionResults} primary={state.primaryAddiction} />

        {!extended ? (
          <UnlockPanel onStart={() => dispatch({ type: 'SET_SCREEN', payload: 'extendedAssessment' })} />
        ) : (
          <>
            <LifeImpactSection lifeImpact={m.lifeImpact} />
            <MentalHealthSection scores={state.dassScores} severities={severities} />
            <ProfileSection profile={m.behavioralProfile} readiness={m.recoveryReadiness} />
          </>
        )}

        <ResultsFooter onRestart={() => dispatch({ type: 'RESET_ASSESSMENT' })} />
      </main>
    </Shell>
  )
}

export default ResultsPage
